import type { BenefitSummary, BenefitsData } from "@yutai/shared"
import useSWR from "swr"

const R2_URL = import.meta.env.VITE_R2_PUBLIC_URL ?? ""
const BENEFITS_URL = import.meta.env.DEV ? `${R2_URL}/benefits.json` : "/benefits.json"

async function fetcher(url: string): Promise<BenefitSummary[]> {
  const res = await fetch(url)
  if (!res.ok) throw new Error(`Failed to fetch: ${res.status}`)
  const data: BenefitsData = await res.json()
  return data.items.map((item) => ({
    ...item,
    tags: item.tags ?? [],
    deliveryMonths: item.deliveryMonths ?? [],
    holdingYears: item.holdingYears ?? [],
    minimumBenefitValue: item.minimumBenefitValue ?? null,
    tiers: item.tiers ?? [],
    tiersNeedDescription: item.tiersNeedDescription ?? false,
    title: item.title ?? "",
    businessDescription: item.businessDescription ?? "",
    benefitRelevanceScore: item.benefitRelevanceScore ?? 0,
    approxStockPrice: item.approxStockPrice ?? null,
    marketCap: item.marketCap ?? null,
    dividendYield: item.dividendYield ?? null,
    benefitYield: item.benefitYield ?? null,
    financialsUpdatedAt: item.financialsUpdatedAt ?? null,
  }))
}

// The full, unfiltered/unpaginated benefits.json — shared SWR cache key, so
// this dedupes against useBenefits.ts's own fetch of the same URL. Used
// wherever a lookup by companyId is needed (CompanyPage, list detail/holding
// views) rather than the filtered list BenefitListPage works with.
export function useAllBenefits() {
  return useSWR<BenefitSummary[]>(BENEFITS_URL, fetcher, {
    revalidateOnFocus: false,
    dedupingInterval: 3600_000,
  })
}
